package ai.jessie.web.settings

/**
 * One card of the settings page (`19-EinstellungenOrganisation.png`): its scalar fields in the
 * form's [rows] (one, two or three fields side by side).
 */
internal data class SettingsSection(
    val title: String,
    val description: String?,
    val rows: List<List<String>>,
) {
    val fields: List<String>
        get() = rows.flatten()
}

// The artboard's four cards; fields the contract does not provide (legal name, logo, bank name,
// QR-IBAN, BIC) are omitted. Time zone belongs to the address card.
internal val settingsSections =
    listOf(
        SettingsSection("Namen", "Der Name der Organisation in jessie.ai.", listOf(listOf("name"))),
        SettingsSection(
            "Adresse",
            "Wird als Absender auf Rechnungen verwendet.",
            listOf(listOf("address"), listOf("countryCode", "timeZone")),
        ),
        SettingsSection(
            "Rechnungsinformationen",
            null,
            listOf(
                listOf("vatNumber", "invoicePrefix", "nextInvoiceNumber"),
                listOf("defaultCurrency", "invoiceLanguage", "paymentTermsDays"),
                listOf("automaticDocumentExtraction"),
            ),
        ),
        SettingsSection(
            "Bankverbindung",
            "Erscheint im Zahlteil der Rechnung.",
            listOf(listOf("iban")),
        ),
    )

/** Values shown and entered in Dank Mono. */
internal val numericSettings = setOf("nextInvoiceNumber", "paymentTermsDays", "iban")

/** The review section a changed field belongs to; history fields map like their scalar names. */
internal fun sectionTitle(field: String): String {
    val kind = field.substringBefore("[")
    return when {
        kind == "invoiceSequence" -> "Rechnungsinformationen"
        kind == "vatRate" -> "MWST-Versionen"
        kind == "documentCategory" -> "Dokumentkategorien"
        kind == "documentFolder" -> "Dokumentordner"
        else -> settingsSections.firstOrNull { field in it.fields }?.title ?: "Weitere"
    }
}
